const loadScript = src => (new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('src', src);
    document.head.appendChild(script);

    script.onload = resolve;
    script.onerror = reject;
}));

export default loadScript;
